import React from 'react';
import Body from 'react-muscle-highlighter';

export const MUSCLE_COLORS = ['#fecaca', '#f87171', '#ef4444', '#dc2626'];

export const MuscleBodies = ({ data, onPress, labels, className = '' }) => {
  const bodyData = (data?.regions || []).map((r) => ({ slug: r.slug, intensity: r.level }));
  const props = { data: bodyData, colors: MUSCLE_COLORS, gender: data?.gender || 'male', defaultFill: '#3f3f46', defaultStroke: '#18181b', border: '#71717a' };
  if (onPress) props.onBodyPartPress = (p) => p?.slug && onPress(p.slug);
  return (
    <div className={`flex justify-center gap-3 muscle-map-bodies ${className}`}>
      {['front', 'back'].map((side) => (
        <div key={side} className="w-[46%] max-w-[170px]" data-testid={`muscle-map-${side}`}>
          <Body {...props} side={side} />
          {labels && <div className="text-center text-[11px] text-gray-400 mt-1">{labels[side]}</div>}
        </div>
      ))}
    </div>
  );
};

export const MuscleLegend = ({ t }) => (
  <div className="flex flex-wrap justify-center gap-x-3 gap-y-1 text-[11px] text-gray-300 mt-3" data-testid="muscle-map-legend">
    <span className="flex items-center gap-1"><i className="w-3 h-3 rounded-sm inline-block" style={{ background: '#3f3f46' }} />{t.none}</span>
    {MUSCLE_COLORS.map((c, i) => (
      <span key={c} className="flex items-center gap-1"><i className="w-3 h-3 rounded-sm inline-block" style={{ background: c }} />{t.levels[i]}</span>
    ))}
  </div>
);
